"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hamburgerFullWidth = _interopRequireDefault(require("../../assets/svg/hamburger-full-width.svg"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Sidebar = function Sidebar(_ref) {
  var width = _ref.width,
    onLogout = _ref.onLogout,
    children = _ref.children,
    isClosed = _ref.isClosed,
    inlineToggleButton = _ref.inlineToggleButton;
  var _useState = (0, _react.useState)(-width),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var containerRef = (0, _react.useRef)();
  var toggleMenu = function toggleMenu() {
    if (position < 0) {
      setPosition(0);
    } else {
      setPosition(-width);
    }
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (!containerRef || !containerRef.current.contains(event.target)) {
      setPosition(-width);
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isClosed && position <= 0) {
      setPosition(-width);
    }
  }, [isClosed, position]);
  var showFixedToggleButton = !inlineToggleButton || inlineToggleButton && position === 0;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef
  }, showFixedToggleButton && /*#__PURE__*/_react.default.createElement(_styled.ToggleButton, {
    id: "toggle-icon",
    onClick: toggleMenu,
    close: position !== -width,
    isOpen: position === 0,
    className: "button-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "top ".concat(position === 0 ? 'open' : '')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "mid ".concat(position === 0 ? 'open' : '')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "bot ".concat(position === 0 ? 'open' : '')
  })), inlineToggleButton && /*#__PURE__*/_react.default.createElement(_styled.StyledIconButton, {
    onClick: function onClick() {
      return setPosition(0);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _hamburgerFullWidth.default,
    alt: "hamburger"
  })), /*#__PURE__*/_react.default.createElement(_styled.Container, {
    transform: position,
    width: "".concat(width, "px")
  }, /*#__PURE__*/_react.default.createElement(_styled.WrapperContent, {
    visibility: position
  }, onLogout && /*#__PURE__*/_react.default.createElement(_styled.LogOutButton, {
    onClick: onLogout,
    noBorder: true
  }, "SIGN OUT"), /*#__PURE__*/_react.default.createElement(_styled.Content, null, children))));
};
Sidebar.propTypes = {
  width: _propTypes.default.number,
  onLogout: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.arrayOf(_propTypes.default.shape({}))]),
  isClosed: _propTypes.default.bool,
  inlineToggleButton: _propTypes.default.bool
};
Sidebar.defaultProps = {
  width: 300,
  children: null,
  onLogout: undefined,
  isClosed: false,
  inlineToggleButton: false
};
var _default = Sidebar;
exports.default = _default;